<template>
  <div>
    <v-speed-dial
      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      fixed
      :direction="direction"
      :open-on-hover="hover"
      :transition="transition"
      class="glass-speed-dial"
      v-if="
        $route.name !== 'cashRegister' &&
        !$route.name.includes('recapitulation') &&
        !$route.name.includes('orders') &&
        !$route.name.includes('companies') &&
        !$route.name.includes('suppliers') &&
        !$route.name.includes('documentsv2') &&
        !$route.name.includes('businessSettings')
      "
    >
      <template v-slot:activator>
        <v-btn v-model="fab" dark fab class="glass-fab-main">
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-menu</v-icon>
        </v-btn>
      </template>

      <v-btn
        dark
        medium
        class="glass-fab-item glass-fab-racun"
        @click="navigateToCashRegister"
      >
        <v-icon>mdi-cash-register</v-icon>
        <span>Novi račun</span>
      </v-btn>

      <v-btn
        dark
        medium
        class="glass-fab-item glass-fab-izvjestaji"
        @click="openMaster"
      >
        <v-icon>mdi-file-chart-outline</v-icon>
        <span>Izvještaji</span>
      </v-btn>

    </v-speed-dial>
  </div>
</template>
<script>

import state from '@/state'
import { auth, df } from '@/plugins/firebase'

export default {
  name: 'FabMenu',
  inject: [],
  components: {},
  data: function () {
    return {
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: 'slide-x-reverse-transition',
      direction: 'top',
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      cashRegisterTarget: 'cashRegisters'
    }
  },
  computed: {
    showNewWarehouseDocumentBtn () {
      var show = false
      if (state.getCurrentCompany().warehouse === 'module') {
        show = true
      }

      return show
    },
    cashRegisterLabel () {
      if (this.cashRegisterTarget === 'companies') return 'Firme'
      if (this.cashRegisterTarget === 'pointsOfSale') return 'Prodajna mjesta'
      return 'Blagajna'
    }
  },
  created () {
  },
  mounted () {
    this.resolveCashRegisterTarget()
  },
  methods: {
    openWarehouseNewDocument () {
      var targetModifier = this.getTargetModifier()
      var companyId = this.getCompanyId()
      var locationId = this.getLocationId()

      var route = {
        name: `${targetModifier}.warehouseModule.documents`,
        params: {
          companyId: companyId
        }
      }

      if (locationId !== '') {
        route.locationId = locationId
      }

      this.$router.push(route)
    },
    openMaster () {
      var targetModifier = this.getTargetModifier()
      var companyId = this.getCompanyId()
      var locationId = this.getLocationId()

      var route = {
        name: `${targetModifier}.all-reports.reportMenu`,
        params: {
          companyId: companyId
        }
      }

      if (locationId !== '') {
        route.locationId = locationId
      }

      this.$router.push(route)
    },

    getCompanyId () {
      var companyId = ''
      if (state.getCurrentCompany() && state.getCurrentCompany().id && state.getCurrentCompany().id !== null && state.getCurrentCompany().id !== undefined) {
        companyId = state.getCurrentCompany().id
      }

      return companyId
    },

    getLocationId () {
      var locationId = ''
      if (state.getPointOfSale() && state.getPointOfSale().id && state.getPointOfSale().id !== null && state.getPointOfSale().id !== undefined) {
        locationId = state.getPointOfSale().id
      }

      return locationId
    },

    getTargetModifier () {
      var sideNav = this.$route.meta.sideNav

      var targetModifier = ''
      switch (sideNav) {
        case 'Companies':
          break
        case 'Company':
          targetModifier = 'company'
          break
        case 'PointOfSale':
          targetModifier = 'pointOfSale'
          break
        case 'CashRegister':
          targetModifier = 'pointOfSale'
          break
      }

      return targetModifier
    },
    async resolveCashRegisterTarget () {
      try {
        const uid = auth.currentUser?.uid
        if (!uid) return

        const companiesDoc = await df.doc(`user_companies/${uid}`).get()
        const companies = Object.values(companiesDoc.data()?.companies || {})

        if (companies.length !== 1) {
          this.cashRegisterTarget = 'companies'
          return
        }

        const locationsDoc = await df.doc(`user_locations/${uid}.${companies[0].id}`).get()
        const locations = Object.values(locationsDoc.data()?.locations || {})

        this.cashRegisterTarget = locations.length !== 1 ? 'pointsOfSale' : 'cashRegisters'
      } catch (e) {
        // ostavi default
      }
    },
    async navigateToCashRegister () {
      const uid = auth.currentUser.uid
      const navigate = (route) => this.$router.push(route).catch(e => {
        if (e.name !== 'NavigationDuplicated') throw e
      })

      const companiesDoc = await df.doc(`user_companies/${uid}`).get()
      const companies = Object.values(companiesDoc.data()?.companies || {})

      if (companies.length !== 1) {
        navigate({ name: 'companies' })
        return
      }

      const company = companies[0]

      const locationsDoc = await df.doc(`user_locations/${uid}.${company.id}`).get()
      const locations = Object.values(locationsDoc.data()?.locations || {})

      if (locations.length !== 1) {
        navigate({ name: 'company.pointsOfSale', params: { companyId: company.id } })
        return
      }

      navigate({
        name: 'pointOfSale.cashRegisters',
        params: { companyId: company.id, locationId: locations[0].id }
      })
    }
  }
}
</script>

<style scoped>
/* Glass Speed Dial Container */
.glass-speed-dial {
  z-index: 100 !important;
}

/* Main FAB Button - Brand Gradient */
.glass-fab-main {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.95) 0%,
    rgba(57, 137, 201, 0.9) 50%,
    rgba(97, 84, 164, 0.95) 100%) !important;
  border: 2px solid rgba(255, 255, 255, 0.4) !important;
  box-shadow: 0 8px 24px rgba(0, 179, 190, 0.35) !important;
  backdrop-filter: blur(10px) !important;
  width: 56px !important;
  height: 56px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.glass-fab-main:hover {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 1) 0%,
    rgba(57, 137, 201, 0.95) 50%,
    rgba(97, 84, 164, 1) 100%) !important;
  transform: scale(1.08) rotate(5deg);
  box-shadow: 0 12px 32px rgba(0, 179, 190, 0.5) !important;
  border-color: rgba(255, 255, 255, 0.6) !important;
}

.glass-fab-main .v-icon {
  color: white !important;
  font-size: 28px !important;
  transition: all 0.3s ease;
}

.glass-fab-main:hover .v-icon {
  transform: rotate(0deg);
}

/* FAB Item Base Style */
.glass-fab-item {
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2) !important;
  border-radius: 28px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 0 20px !important;
  height: 48px !important;
  min-width: 140px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  margin-bottom: 12px !important;
  margin-right: 8px !important;
}

.glass-fab-item:hover {
  transform: translateX(-8px) scale(1.05);
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.glass-fab-item .v-icon {
  margin-right: 8px !important;
  font-size: 20px !important;
  transition: all 0.3s ease;
}

.glass-fab-item:hover .v-icon {
  transform: scale(1.1) rotate(5deg);
}

.glass-fab-item span {
  font-weight: 600 !important;
  color: white !important;
}

/* Račun Button - Success/Green */
.glass-fab-racun {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 0.95) 0%,
    rgba(56, 142, 60, 0.9) 100%) !important;
}

.glass-fab-racun:hover {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 1) 0%,
    rgba(56, 142, 60, 1) 100%) !important;
  box-shadow: 0 8px 24px rgba(76, 175, 80, 0.45) !important;
}

/* Izvještaji Button - Primary Blue */
.glass-fab-izvjestaji {
  background: linear-gradient(135deg,
    rgba(57, 137, 201, 0.95) 0%,
    rgba(33, 97, 140, 0.9) 100%) !important;
}

.glass-fab-izvjestaji:hover {
  background: linear-gradient(135deg,
    rgba(57, 137, 201, 1) 0%,
    rgba(33, 97, 140, 1) 100%) !important;
  box-shadow: 0 8px 24px rgba(57, 137, 201, 0.45) !important;
}

/* Primka Button - Warning/Orange */
.glass-fab-primka {
  background: linear-gradient(135deg,
    rgba(255, 152, 0, 0.95) 0%,
    rgba(245, 124, 0, 0.9) 100%) !important;
}

.glass-fab-primka:hover {
  background: linear-gradient(135deg,
    rgba(255, 152, 0, 1) 0%,
    rgba(245, 124, 0, 1) 100%) !important;
  box-shadow: 0 8px 24px rgba(255, 152, 0, 0.45) !important;
}

/* Animation for speed dial items */
.glass-speed-dial .v-speed-dial__list {
  padding: 0 !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .glass-fab-main {
    width: 48px !important;
    height: 48px !important;
  }

  .glass-fab-item {
    min-width: 120px !important;
    font-size: 13px !important;
    height: 44px !important;
  }

  .glass-fab-item .v-icon {
    font-size: 18px !important;
  }
}
</style>
